module.exports = __webpack_public_path__ + "static/img/biasfx-icon@2x.6d4e5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx-mobile/biasfx-icon@2x.png
// module id = 5iEY
// module chunks = 13